<script setup lang="ts">
import {
  DialogContent,
  type DialogContentEmits,
  type DialogContentProps,
  DialogOverlay,
  DialogPortal,
  DialogTitle,
  useForwardPropsEmits,
  VisuallyHidden
} from 'radix-vue'
import { computed, type HTMLAttributes, PropType } from 'vue'
import { type SheetVariants, sheetVariants } from '.'
import { cn } from '@/components/utils'

interface SheetContentProps extends DialogContentProps {
  class?: HTMLAttributes['class']
  side?: SheetVariants['side']
  overlayClass?: unknown
}

defineOptions({
  inheritAttrs: false
})

const props = defineProps<SheetContentProps>()

const emits = defineEmits<DialogContentEmits>()

const delegatedProps = computed(() => {
  const { class: _, side, ...delegated } = props

  return delegated
})

const forwarded = useForwardPropsEmits(delegatedProps, emits)
</script>

<template>
  <DialogPortal>
    <DialogOverlay
      :class="`fixed inset-0 z-30 bg-dark/80 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 ${props.overlayClass}`"
    />
    <DialogContent
      :class="cn(sheetVariants({ side }), props.class)"
      v-bind="{ ...forwarded, ...$attrs }"
      aria-describedby=""
    >
      <VisuallyHidden>
        <DialogTitle />
      </VisuallyHidden>
      <slot />
    </DialogContent>
  </DialogPortal>
</template>
